﻿'use strict';

var centralApp = angular.module('app.components');

centralApp.component('tempoDecorrido', {
    bindings: {
        data: '=',
        real: '=?'
    },
    controllerAs: '$ctrl',
    controller: tempoController,
    template: '<span ng-bind="$ctrl.tempo"></span>'
});

tempoController.$inject = ['$interval', '$filter'];
function tempoController($interval, $filter) {

    var $ctrl = this;

    $ctrl.tempo = $filter('tempoDecorrido')($ctrl.data);

    if ($ctrl.real) {
        $interval(function () {
            $ctrl.tempo = $filter('tempoDecorrido')($ctrl.data);
        }, 1000);
    }
}



//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/tempo-decorrido/index.js
// module id = 320
// module chunks = 1